import React from 'react';
import { css } from '@emotion/css';
import { Color } from 'css/theme';
import { spacing } from '@prezzee/tokens';

import { SortOption } from './index';

const classes = {
  item: (isActive: boolean) => css`
    cursor: pointer;
    padding: ${spacing.spacing035};
    transition: 0.3s;
    color: ${isActive ? Color.Blue400 : 'initial'};
    font-size: 14px;
    background-color: ${isActive ? Color.Lilac50 : 'initial'};

    :hover {
      background-color: ${Color.Lilac50};
    }
  `,
};

type Props = {
  option: SortOption;
  activeOption: SortOption;
  setSortOption: (option: SortOption) => void;
  onClose: () => void;
};

const SelectItem: React.FC<Props> = ({ option, activeOption, setSortOption, onClose }) => {
  return (
    <li
      aria-hidden="true"
      onClick={() => {
        setSortOption(option);
        onClose();
      }}
      className={classes.item(option && activeOption ? option.value === activeOption.value : false)}
    >
      {option.label}
    </li>
  );
};

export default SelectItem;
